export default __webpack_public_path__ + "static/media/logo.e670eee7.png";